import React, { useState } from 'react';
import { auth } from '../firebase';
import { sendSignInLinkToEmail } from "firebase/auth";
import { TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HomeLogo from './HomeLogo';

const SignUp = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');

    const handleEmailChange = (e) => setEmail(e.target.value);
    const handleNameChange = (e) => setName(e.target.value);

    const handleSubmit = () => {
        const actionCodeSettings = {
            url: `${window.location.origin}/finishSignUp?name=${encodeURIComponent(name)}`,
            handleCodeInApp: true,
        };

        sendSignInLinkToEmail(auth, email, actionCodeSettings)
            .then(() => {
                window.localStorage.setItem('emailForSignIn', email);
                alert('Check your email for the sign-up link');
            })
            .catch((error) => {
                console.error(error);
            });
    };

    return (
        <div className="sg-page">
            <HomeLogo />
            <div className="sg-center-col" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingBottom: '10vh' }}>
                <div className="sg-card sg-anim-fadeup" style={{ textAlign: 'center' }}>
                    <span className="sg-kicker">New here?</span>
                    <h2 style={{ fontSize: '2rem', margin: '8px 0 6px' }}>
                        Create your player ✨
                    </h2>
                    <p className="sg-muted" style={{ margin: '0 0 18px' }}>
                        We'll email you a magic sign-in link.
                    </p>
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Name"
                        value={name}
                        onChange={handleNameChange}
                    />
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Email"
                        type="email"
                        value={email}
                        onChange={handleEmailChange}
                    />
                    <button
                        type="submit"
                        className="sg-btn sg-btn--primary sg-btn--block sg-btn--lg"
                        onClick={handleSubmit}
                        style={{ marginTop: 18 }}
                    >
                        Send my link →
                    </button>
                    <p className="sg-muted" style={{ margin: '18px 0 0' }}>
                        or <span className="sg-link" onClick={() => navigate('/login')}>log in instead</span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SignUp;